import { dayjs } from '@utils/dayjs';

// ISO week (Monday first), independent of the locale's weekStart
export const getWeekToDateRange = (now = dayjs()) => [now.startOf('isoWeek'), now];
